import React, { useState, useMemo } from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'

import { Cross } from '../components/UI/Cross'
import { PopupBox } from '../components/popups/PopupBox'
import { colors } from '../styles/colors'
import { PrimaryButton } from '../components/UI/PrimaryButton'
import { useFirebase } from 'react-redux-firebase'
import { fire_storage } from '../store'
import { PhotoInput } from '../components/UI/PhotoInput'
import { processNewPhoto } from '../functions/processNewPhoto'
import { Loading } from '../components/UI/Loading'

const Container = styled.div`
    width: 100%;
    height: 100%;
    overflow: auto;

    position: fixed;
    top: 0:
    left: 0;
    z-index: 10;
    background: rgba(255, 255, 255, 0.5);

    padding: 2rem;

    // INCLUDED CLASSES:

    .popup-box {
        margin: 5rem auto;
    }
    .title {
        max-width: 500px;
        font-family: 'SF UI Text',sans-serif;
        font-weight: 400;
        font-size: 3.75rem;
        line-height: 160%;
        color: ${colors.white};
        margin-bottom: 3.75rem;
    }

    .input-description, p {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        font-size: 2rem;
        line-height: 160%;
        color: ${colors.white};
        margin-bottom: 1rem;
    }

    .input {
        width: 100%;
        height: 55px;
        color: ${colors.dark_blue};

        padding-left: 2.5rem; 

        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;

        outline: none;

        :not(:last-child) {
            margin-bottom: 3.75rem;
        }

        ::placeholder {
            font-family: 'SF UI Text',sans-serif;
            font-weight: 300;
            font-size: 2.5rem;
            line-height: 150%;    
            color: ${colors.dark_blue};
        }

        @media (max-width: 767.98px) {
            flex-direction: column;
            margin-bottom: 3.75rem;
        }
    }

    input[type='number'] {
        ::-webkit-inner-spin-button,
        ::-webkit-outer-spin-button {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            margin: 0;
        }
    }

    .submit-button {
        width: 200px;
        margin: 3rem auto 0 auto;
    }

    .textarea {
        width: 100%;
        min-height: 200px;
        margin-bottom: 3.75rem;
        outline: none;
        padding: 2.5rem;

        font-family: 'SF UI Text',sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;

        color: ${colors.dark_blue};

        ::placeholder {
            font-family: 'SF UI Text',sans-serif;
            font-weight: 300;
            font-size: 2.5rem;
            line-height: 150%;    
            color: ${colors.dark_blue};
        }

        @media (max-width: 767.98px) {
            flex-direction: column;
            margin: 0;
        }

    }
    .photo-inputs {
        display: flex;
        justify-content: space-evenly;
        margin: 2rem 0 6rem 0;
    }
    .photo-input {
        display: flex;
        flex-direction: column;
        align-items: center;

        .cross-button {
            margin-top: 2rem;
            transform: translateX(-50%);

            svg {
                width: 2rem;
                height: 2rem;
            }
        }
        input {
            display: none;
        }
    }

    .success-alert {
        padding: 5rem 0;
        p {
            max-width: 100%;
            text-align: center;
        }
        .submit-button {
            margin-top: 5rem;
        }
    }
    .preloader {
        margin-top: 3rem;
        display: flex;
        justify-content: center;
    }
`

const Success = ({ onclick }) => {
    return (
        <div className='success-alert'>
            <p className="title">Товар успешно изменён!</p>
            <p>Хотите изменить в этом товаре что-то ещё?</p>
            <PrimaryButton className='submit-button' lighten onClick={() => onclick(false)} >Вернуться к редактированию</PrimaryButton>
        </div>
    )
}

export const ChangeProduct = () => {

    const product_data = useSelector(state => state.change_product.data)
    const product_in_db = useFirebase().ref(`products/products_list/${product_data.key}`)

    const dispatch = useDispatch()

    const [successOpened, setSuccessOpened] = useState(false)
    const [loading, setLoading] = useState(false)

    // Pictures state
    const [productPicture, setProductPicture] = useState(product_data.pictures[0])
    const [productPicture1, setProductPicture1] = useState(product_data.pictures[1])
    const [productPicture2, setProductPicture2] = useState(product_data.pictures[2])

    const firstPicture = useMemo(() => <PhotoInput picture={productPicture} setPicture={setProductPicture} />, [productPicture])
    const secondtPicture = useMemo(() => <PhotoInput picture={productPicture1} setPicture={setProductPicture1} />, [productPicture1])
    const thirdPicture = useMemo(() => <PhotoInput picture={productPicture2} setPicture={setProductPicture2} />, [productPicture2])

    // Product data state
    const category = product_data.category
    const [productName, setProductName] = useState(product_data.product_name)
    const [price, setPrice] = useState(product_data.price)
    const [description, setDescription] = useState(product_data.description)
    const [techProps, setTechProps] = useState(product_data.tech_props)

    function handleSubmit() {
        const formated_product_name = productName.toLowerCase().trim().replace(/\s{2,}/g, ' ')

        if (formated_product_name) {
            const pictures = [productPicture, productPicture1, productPicture2]
            const exist_pictures = pictures.filter(e => e ? true : false)

            function update_data_in_database(pictures) {
                const product_data = {
                    pictures,
                    category,
                    product_name: formated_product_name,
                    price,
                    description,
                    tech_props: techProps,
                }
                product_in_db.set(product_data)
                console.log(product_data);
                console.log('Done');
                setSuccessOpened(true)
            }

            if (exist_pictures.length !== 0) {
                console.log('Found some pictures');
                const is_there_new = exist_pictures.filter(pic => !pic.url).length !== 0

                if (is_there_new) {
                    console.log('There is somthing new');
                    const new_pictures = exist_pictures.filter(pic => !pic.url)

                    const ref = fire_storage.ref(`img/products/`)

                    async function processPhotos(length) {
                        const old_photos = exist_pictures.filter(pic => pic.url)
                        setLoading(true)

                        try {
                            switch (length) {
                                case 1:
                                    {
                                        const picture_data = await processNewPhoto(ref, new_pictures[0])
                                        const product_pictures_data = old_photos.concat(picture_data)
                                        update_data_in_database(product_pictures_data)
                                    }
                                    break;
                                case 2:
                                    {
                                        const picture_data = await processNewPhoto(ref, new_pictures[0])
                                        const picture_data1 = await processNewPhoto(ref, new_pictures[1])

                                        const product_pictures_data = old_photos.concat(picture_data, picture_data1)
                                        update_data_in_database(product_pictures_data)
                                    }
                                    break;
                                case 3:
                                    {
                                        const picture_data = await processNewPhoto(ref, new_pictures[0])
                                        const picture_data1 = await processNewPhoto(ref, new_pictures[1])
                                        const picture_data2 = await processNewPhoto(ref, new_pictures[2])

                                        const product_pictures_data = [picture_data, picture_data1, picture_data2]
                                        update_data_in_database(product_pictures_data)
                                    }
                                    break;

                                default:
                                    break;
                            }
                        } catch {
                            return
                        } finally {
                            setLoading(false)
                        }

                    }
                    processPhotos(new_pictures.length)

                } else {
                    console.log('Nothing new');
                    const updated_pictures_array = exist_pictures
                    update_data_in_database(updated_pictures_array)
                }

            } else {
                console.log('No pictures');
                const updated_pictures = ['']
                update_data_in_database(updated_pictures)
            }

        } else {
            alert('Пожалуйста, заполните поле "Наименование товара"')
            return
        }
    }

    return (
        <Container>
            <PopupBox className='popup-box'>
                <div onClick={() => dispatch({ type: 'CHANGE_PRODUCT_CLOSED' })}> <Cross lighten /> </div>

                {successOpened
                    ? <Success onclick={setSuccessOpened} />
                    : <>
                        <p className="title">Изменить продукт</p>

                        <div className="inputs">

                            <p className='input-description'>Фото товара</p>
                            <div className="photo-inputs">
                                {firstPicture}
                                {secondtPicture}
                                {thirdPicture}
                            </div>

                            <p className='input-description'>Наименование товара *</p>
                            <input className='input' placeholder='Наименование товара *' type="text" value={productName} onChange={(e) => setProductName(e.target.value)} required />

                            <p className='input-description'>Введите цену в рублях без копеек (например: 7600) <br /> или оставьте поле пустым (если цена по запросу)</p>
                            <input className='input' type="number" placeholder='Цена, р' value={price} onChange={(e) => setPrice(e.target.value)} />

                            <p className='input-description'>Описание товара</p>
                            <textarea className='textarea' placeholder='Описание товара' value={description} onChange={(e) => setDescription(e.target.value)} ></textarea>

                            <p className='input-description'>Технические характеристики</p>
                            <textarea className='textarea' placeholder='Технические характеристики' value={techProps} onChange={(e) => setTechProps(e.target.value)} ></textarea>

                        </div>
                        <p>* - обязательные поля</p>  <hr /> <br />
                        <p>В полях "Описание ... " и "Технические ... " используйте: <br />
                            {`<br/>`} - для принудительного перехода на новую строку; <br />
                            {`<b> ваш текст </b>`} - выделяет текст жирным цветом; <br />
                            {`<i> ваш текст </i>`} - задает стиль текста - курсив; <br /><br />
                            Это не влияет на текст внутри поля, но вносит изменения при выводе информации в блоке товара.
                        </p>

                        {loading
                            ? <Loading lighten />
                            : <PrimaryButton lighten className='submit-button' onClick={() => handleSubmit()}>Применить изменения</PrimaryButton>
                        }
                        
                    </>
                }
            </PopupBox>
        </Container>
    )
}
